import type { MenuItem } from './types';

export function splitItems(menuItems: MenuItem[]) {
  const leftSideMenu = menuItems.slice(0, Math.floor(menuItems.length / 2));
  const rightSideMenu = menuItems.slice(Math.floor(menuItems.length / 2));

  return { leftSideMenu, rightSideMenu };
}
